import React from 'react';
import FooterRotationLogoText from '../components/footer-rotation-logo-text';
import TimelimeRotationLogoText from '../components/timeline-rotation-logo-text';

const RenderComponent = (props: any) => {
  function renderComponent(type: string, data: any) {
    switch (type) {
      case 'footer-logo-rotation-text': {
        return <FooterRotationLogoText text={data.text} letterSpacing={data.letterSpacing} fontSize={data.fontSize} />;
      }
      case 'timeline-logo-rotation-text': {
        return (
          <TimelimeRotationLogoText
            text={data.text}
            letterSpacing={data.letterSpacing}
            fontSize={data.fontSize}
            image={data.image}
          />
        );
      }
      default: {
        return null;
      }
    }
  }

  return renderComponent(props.widgetType, props.widgetData);
};

export default RenderComponent;
